
import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const apiUrl = "https://elcobradorleague.com/api";

// Función fetch de partidos por liga
const fetchMatchesByLeague = async (leagueId) => {
  const { data } = await axios.get(`${apiUrl}/api.php?endpoint=matches&idleague=${leagueId}`);
  return data;
};

/**
 * Hook useMatches
 * @param {number} leagueId - ID de la liga
 * @returns {object} { data, isLoading, isError, refetch }
 */
export const useMatches = (leagueId) => {
  return useQuery({
    queryKey: ["matches", leagueId],
    queryFn: () => fetchMatchesByLeague(leagueId),
    staleTime: 60 * 1000, // 1 minuto
    refetchOnWindowFocus: false,
    enabled: !!leagueId, // solo ejecuta si leagueId es válido
  });
};
